import * as React from 'react';

const EnFlag = () => {
  return (
    <svg
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3784_1380)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V18H24V0H0Z"
          fill="#2E42A5"
        />
        <mask
          id="mask0_3784_1380"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="18"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V18H24V0H0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_3784_1380)">
          <path
            d="M-2.66797 16.7142L2.6133 18.9478L24.1242 2.42854L26.91 -0.890572L21.2624 -1.63709L12.4886 5.48151L5.42662 10.2778L-2.66797 16.7142Z"
            fill="white"
          />
          <path
            d="M-1.94531 18.279L0.745249 19.5752L25.9093 -1.19901H22.1314L-1.94531 18.279Z"
            fill="#F50100"
          />
          <path
            d="M26.6758 16.7142L21.3945 18.9478L-0.116413 2.42854L-2.90216 -0.890572L2.74539 -1.63709L11.5192 5.48151L18.5812 10.2778L26.6758 16.7142Z"
            fill="white"
          />
          <path
            d="M26.4922 17.8371L23.8016 19.1333L13.0865 10.2388L9.90973 9.24502L-3.1736 -0.879375H0.604259L13.6802 9.00471L17.1535 10.1963L26.4922 17.8371Z"
            fill="#F50100"
          />
          <mask id="path-8-inside-1_3784_1380" fill="white">
            <path d="M14.835 6H25.5234V12H14.835V19.5H9.16797V12H-1.47656V6H9.16797V-1.5H14.835V6Z" />
          </mask>
          <path
            d="M14.835 6H25.5234V12H14.835V19.5H9.16797V12H-1.47656V6H9.16797V-1.5H14.835V6Z"
            fill="#F50100"
          />
          <path
            d="M14.835 6H13.335V7.5H14.835V6ZM25.5234 6H27.0234V4.5H25.5234V6ZM25.5234 12V13.5H27.0234V12H25.5234ZM14.835 12V10.5H13.335V12H14.835ZM14.835 19.5V21H16.335V19.5H14.835ZM9.16797 19.5H7.66797V21H9.16797V19.5ZM9.16797 12H10.668V10.5H9.16797V12ZM-1.47656 12H-2.97656V13.5H-1.47656V12ZM-1.47656 6V4.5H-2.97656V6H-1.47656ZM9.16797 6V7.5H10.668V6H9.16797ZM9.16797 -1.5V-3H7.66797V-1.5H9.16797ZM14.835 -1.5H16.335V-3H14.835V-1.5ZM14.835 6V7.5H25.5234V6V4.5H14.835V6ZM25.5234 6H24.0234V12H25.5234H27.0234V6H25.5234ZM25.5234 12V10.5H14.835V12V13.5H25.5234V12ZM14.835 12H13.335V19.5H14.835H16.335V12H14.835ZM14.835 19.5V18H9.16797V19.5V21H14.835V19.5ZM9.16797 19.5H10.668V12H9.16797H7.66797V19.5H9.16797ZM9.16797 12V10.5H-1.47656V12V13.5H9.16797V12ZM-1.47656 12H0.0234375V6H-1.47656H-2.97656V12H-1.47656ZM-1.47656 6V7.5H9.16797V6V4.5H-1.47656V6ZM9.16797 6H10.668V-1.5H9.16797H7.66797V6H9.16797ZM9.16797 -1.5V0H14.835V-1.5V-3H9.16797V-1.5ZM14.835 -1.5H13.335V6H14.835H16.335V-1.5H14.835Z"
            fill="white"
            mask="url(#path-8-inside-1_3784_1380)"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3784_1380">
          <rect width="24" height="18" rx="2" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EnFlag;
